export default "__VITE_ASSET__CZMF_BvG__"